import { OutfitterAssetFamilySchemas, ProductLine } from 'polaris-adventures-js'
import { match } from 'ts-pattern'

export interface ProductLineMarketingMaterial {
  title: string
  description: string
  imageUrl: string
  imageAlt: string
}

export function getMarketingMaterialForProductLine(productLine: ProductLine): ProductLineMarketingMaterial {
  return match(productLine)
    .with('RGR', () => ({
      title: 'RANGER',
      description:
        'An easy-to-handle side by side with a smooth ride. The spacious interior offers plenty of leg room, ample storage for all your gear, and seating for up to four, so friends and family can ride in comfort.',
      imageUrl: '/img/RGR2.png',
      imageAlt:
        'Polaris Ranger XP 1000 utility vehicle in dark gray with protective cab and cargo bed, designed for rugged use.'
    }))
    .with('RZR', () => ({
      title: 'RZR',
      description:
        "The world's leading recreational side by side. The ultimate trail machine handles turns, rocks, mud, sand with ease.",
      imageUrl: '/img/RZR2.png',
      imageAlt:
        'Vibrant blue and black Polaris RZR Turbo R with aggressive off-road tires, showcasing a sporty and rugged design for all-terrain use.'
    }))
    .with('GEN', () => ({
      title: 'General',
      description:
        'The perfect crossover side by side combines the trail-dominating performance of the RZR with the comfort and cargo space of the Ranger.',
      imageUrl: '/img/GEN2.png',
      imageAlt:
        'Bright blue Polaris General XP 1000 four-seater with cargo bed and off-road capabilities, isolated on white.'
    }))
    .with('ATV', () => ({
      title: 'Sportsman',
      description: 'Ride with confidence and comfort in a Sportsman ATV. A smooth suspension means all day comfort.',
      imageUrl: '/img/ATV1.png',
      imageAlt:
        'A new Polaris all-terrain vehicle (ATV) in blue and black, with rugged tires and a mounted storage box on a white background.'
    }))
    .with('IND', () => ({
      title: 'Indian Motorcycles',
      description:
        'With an impressive array of Indian Motorcycle models in the rental lineup, you can choose the bike best suited for your favorite type of riding.',
      imageUrl: '/img/IND1.jpg',
      imageAlt: 'Sleek black Polaris touring motorcycle with hard side bags and a windscreen, on a white background.'
    }))
    .with('SNO', () => ({
      title: 'Snowmobiles',
      description:
        'Trail snowmobiles are the performance standard, with a smooth and stable ride for all experience levels. Mountain sleds tackle deep snow with ease. Choose the perfect sled for you.',
      imageUrl: '/img/SNO1.png',
      imageAlt:
        'Modern Polaris snowmobile in white, blue, and black colors with blue skis, ready for winter adventures, isolated on a white background.'
    }))
    .with('SLG', () => ({
      title: 'Slingshot',
      description:
        'With an open air cockpit placing you 5 inches off the ground, this 3-wheeled roadster delivers a 360-degree visceral experience with the rush of the pavement going by under your seat.',
      imageUrl: '/img/SLG1.png',
      imageAlt:
        'Charcoal gray Polaris Slingshot three-wheeled vehicle, showcasing its distinctive, angular design and open cockpit, isolated on a white background.'
    }))
    .with('PON', () => ({
      title: 'Boats',
      description:
        'Premium brands of boats are of high quality and craftsmanship, designed to provide the perfect day on the water for activities such as fishing, swimming and cruising.',
      imageUrl: '/img/PON1.png',
      imageAlt:
        'Sleek modern pontoon boat by Godfrey in white and black with stylish seating and sun canopy, isolated on a white background.'
    }))
    .otherwise(() => {
      throw new Error(`Unrecognized product line ${productLine}`)
    })
}

export function getMarketingMaterialForVehicleType(
  vehicleType: OutfitterAssetFamilySchemas.VehicleType
): ProductLineMarketingMaterial | null {
  return match(vehicleType)
    .with('SXS', () => ({
      title: 'Side by Sides',
      description:
        'Explore the outdoors in a powerful side by side. From trail-dominating sport models to comfortable utility vehicles, find the perfect ride for your adventure.',
      imageUrl: '/img/RZR2.png',
      imageAlt: 'Polaris side by side off-road vehicle ready for adventure.'
    }))
    .with('Custom', () => null)
    .otherwise((v) => getMarketingMaterialForProductLine(v))
}
